import { useCallback, useState } from 'react';
import { apiPost } from '../../lib/apiClient.js';
import { bannerMessageFrom } from '../../lib/formErrors.js';

/**
 * «تأیید وصول در مقصد» for an in-transit transfer, shared by the transfer list and the movement
 * detail page. Failures are returned as Persian text for a V2Alert, never a browser dialog.
 */
export function useReceiveTransfer(base: string, onReceived: () => void) {
  const [busyId, setBusyId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const receive = useCallback(
    async (movementId: string) => {
      setBusyId(movementId);
      setError(null);
      try {
        await apiPost(
          `${base}/api/v1/inventory/transfers/${encodeURIComponent(movementId)}/receive`,
          {},
          { headers: { 'idempotency-key': crypto.randomUUID() } },
        );
        onReceived();
      } catch (err) {
        setError(bannerMessageFrom(err, 'تأیید وصول انجام نشد.'));
      } finally {
        setBusyId(null);
      }
    },
    [base, onReceived],
  );

  return { busyId, error, clearError: () => setError(null), receive };
}
